import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthStore } from '../state/auth';

export const authCanActivateFn: CanActivateFn = (_route, state) => {
  return canActivateForStage(state);
};

export const authCanActivateChildFn: CanActivateChildFn = (_route, state) => {
  return canActivateForStage(state);
};

/**
 * The only place in the app that turns an {@link AuthStage} into a redirect.
 *
 * It returns a `UrlTree` rather than navigating itself: the router then performs a single
 * navigation to the right place. The stage is read straight off the session token, so this is
 * synchronous.
 */
function canActivateForStage(state: RouterStateSnapshot): boolean | UrlTree {
  const router = inject(Router);
  const stage = inject(AuthStore).stage();

  if (stage === 'anonymous') {
    return router.parseUrl('/login');
  }

  const requestsCreateOrganization = state.url.startsWith('/create-organization');
  const requestsNewPassword = state.url.startsWith('/new-password');

  if (stage === 'pending-new-password') {
    return requestsNewPassword ? true : router.parseUrl('/new-password');
  }

  if (stage === 'needs-organization') {
    // Already at this stage's home — redirecting there again would loop the router forever.
    return requestsCreateOrganization ? true : router.parseUrl('/create-organization');
  }

  // stage is 'ready': the whole app is open, except:
  // - create organization: that is only for organization-less users
  // - new password: that is only for users who need to set a new password
  return requestsCreateOrganization || requestsNewPassword ? router.parseUrl('/') : true;
}
